import { render, staticRenderFns } from "./IndikatorPelayanan.vue?vue&type=template&id=44513eea"
import script from "./IndikatorPelayanan.vue?vue&type=script&lang=js"
export * from "./IndikatorPelayanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44513eea')) {
      api.createRecord('44513eea', component.options)
    } else {
      api.reload('44513eea', component.options)
    }
    module.hot.accept("./IndikatorPelayanan.vue?vue&type=template&id=44513eea", function () {
      api.rerender('44513eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/IndikatorPelayanan.vue"
export default component.exports